import { FC, useState } from 'react';
import { CartItemProps } from './CartItem.types';
import { NumericKeypad } from '@/components/ui/keypads';

export const CartItem: FC<CartItemProps> = ({ item, onUpdateQuantity, onRemove }) => {
  const [keypadOpen, setKeypadOpen] = useState(false);

  const openQuantityKeypad = () => {
    setKeypadOpen(true);
  };

  const handleKeypadSubmit = (value: number) => {
    if (value >= 0) {
      onUpdateQuantity(item.id, value);
    }
  };

  const handleRemove = () => {
    onRemove(item.id);
  };

  return (
    <>
      <div
        className="p-3 border-b border-green-100 bg-green-50 hover:bg-green-100 transition-colors cursor-pointer"
        onClick={handleRemove}
      >
        {/* Fila única: Nombre + Presentación + Cantidad | Precio */}
        <div className="flex items-center gap-1">
          <h4 className="font-medium text-xs flex-1 min-w-0 truncate">
            {item.product.name}
          </h4>
          <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] bg-gray-100 text-gray-600 rounded-md font-medium">
            {item.product.presentationData?.name || item.product.presentation || 'STD'}
          </span>
          <input
            type="text"
            value={item.quantity}
            onClick={(e) => {
              e.stopPropagation();
              openQuantityKeypad();
            }}
            readOnly
            className="flex-shrink-0 w-12 h-7 text-center text-sm font-bold border-2 border-blue-400 rounded-md cursor-pointer bg-white hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <span className="flex-shrink-0 w-[65px] text-right font-medium text-sm text-rose-600">
            S/ {item.subtotal.toFixed(2)}
          </span>
        </div>

        {/* Mostrar consideraciones si existen */}
        {item.product.considerations && item.product.considerations.length > 0 && (
          <div className="mt-2 flex flex-wrap gap-1">
            {item.product.considerations.map((consideration, index) => (
              <span
                key={index}
                className="px-2 py-0.5 text-xs bg-blue-50 text-blue-700 rounded-md font-medium"
              >
                {consideration.name}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Numeric Keypad Modal */}
      <NumericKeypad
        isOpen={keypadOpen}
        onClose={() => setKeypadOpen(false)}
        onSubmit={handleKeypadSubmit}
        title={`Cantidad - ${item.product.name}`}
        initialValue={item.quantity}
      />
    </>
  );
};